export default function Space() {
   return <div className='space'></div>;
}
